import styled from 'styled-components';

export const Section = styled.section`
  padding-bottom: 20px;
`;

export const LinkList = styled.ul`
  display: flex;
  justify-content: center;
  gap: 20px;
`;
